import { Link } from "react-router-dom";
import { Instagram, Mail, Handshake, Users, MapPinned, TrendingUp, ArrowRight } from "lucide-react";
import { Reveal } from "@/lib/motion";

export default function Parcerias() {
  return (
    <div data-testid="parcerias-page" className="pt-32 pb-24">
      <div className="container-rotta">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 text-[#C6A762] mb-5">
            <span className="gold-divider" />
            <span className="text-[11px] tracking-[0.35em] uppercase">Parcerias</span>
          </div>
          <h1 className="font-display text-5xl md:text-6xl text-white leading-[1.0]">
            Conecte sua marca a quem <span className="text-gold-gradient">vive a estrada.</span>
          </h1>
          <p className="text-[#B8B8B8] mt-5 leading-relaxed text-lg">
            A ROTTA conecta motociclistas às melhores estradas, destinos e experiências do Brasil.
            Reunimos uma comunidade apaixonada por viagens de moto — pessoas que planejam roteiros,
            descobrem cidades e consomem produtos e serviços ligados ao mototurismo.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          <Reveal className="card-rotta p-7 bg-[#141414]" delay={0}>
            <div className="w-11 h-11 rounded-full grid place-items-center bg-[#C6A762]/10 text-[#C6A762] border border-[#C6A762]/30 mb-4"><Users size={18} /></div>
            <h3 className="font-display text-xl text-white">Público engajado</h3>
            <p className="text-[#B8B8B8] text-sm mt-2 leading-relaxed">Motociclistas de todo o Brasil que planejam viagens e buscam experiências de qualidade.</p>
          </Reveal>
          <Reveal className="card-rotta p-7 bg-[#141414]" delay={0.1}>
            <div className="w-11 h-11 rounded-full grid place-items-center bg-[#C6A762]/10 text-[#C6A762] border border-[#C6A762]/30 mb-4"><MapPinned size={18} /></div>
            <h3 className="font-display text-xl text-white">Contexto certo</h3>
            <p className="text-[#B8B8B8] text-sm mt-2 leading-relaxed">Sua marca aparece junto a rotas, cidades e pontos de interesse — no momento do planejamento da viagem.</p>
          </Reveal>
          <Reveal className="card-rotta p-7 bg-[#141414]" delay={0.2}>
            <div className="w-11 h-11 rounded-full grid place-items-center bg-[#C6A762]/10 text-[#C6A762] border border-[#C6A762]/30 mb-4"><TrendingUp size={18} /></div>
            <h3 className="font-display text-xl text-white">Segmentos ideais</h3>
            <p className="text-[#B8B8B8] text-sm mt-2 leading-relaxed">Motociclismo, turismo, hospedagem, gastronomia e demais serviços ligados às viagens de moto.</p>
          </Reveal>
        </div>

        <div className="mt-16 card-rotta p-10 md:p-14 bg-gradient-to-br from-[#181818] to-[#101010] grain relative overflow-hidden">
          <div className="relative">
            <div className="flex items-center gap-3 text-[#C6A762] mb-4"><Handshake size={18} /><span className="text-[11px] tracking-[0.35em] uppercase">Vamos conversar</span></div>
            <h2 className="font-display text-3xl md:text-4xl text-white max-w-2xl leading-tight">
              Empresas interessadas em divulgar na ROTTA podem falar diretamente com a gente.
            </h2>
            <div className="mt-8 flex flex-wrap gap-4">
              <a href="mailto:ride.rotta@gmail.com" data-testid="parcerias-email" className="btn-gold px-6 py-4 rounded-full text-xs inline-flex items-center gap-2">
                <Mail size={15} /> ride.rotta@gmail.com
              </a>
              <a href="https://www.instagram.com/ride.rotta/" target="_blank" rel="noreferrer" data-testid="parcerias-instagram" className="btn-ghost px-6 py-4 rounded-full text-xs inline-flex items-center gap-2">
                <Instagram size={15} /> @ride.rotta
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10">
          <Link to="/rotas" className="text-[#C6A762] text-xs tracking-[0.25em] uppercase inline-flex items-center gap-2 hover:translate-x-1 transition-transform">
            Conheça as rotas ROTTA <ArrowRight size={14} />
          </Link>
        </div>
      </div>
    </div>
  );
}
